import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { LoadingService } from "@services/loading.service";
import { LoggerService } from "@services/logger.service";
import { MenuItemsService } from "@services/menu-items.service";

export const menuItemsResolver: ResolveFn<boolean> = async () => {
    const menuItemService = inject(MenuItemsService);
    const logger = inject(LoggerService);
    const loadingService = inject(LoadingService);

    if (menuItemService.menuItems()?.length) return true;

    logger.debug('menuItemsResolver -- menu items loading menu items');
    loadingService.isLoading.set(true);
    await menuItemService.loadMenuItemsAsync();
    loadingService.isLoading.set(false);
    return menuItemService.menuItems()?.length > 0;
};
